import React from "react";
import { NavLink } from "react-router-dom";

const Page404 = () => {
  return (
    <div className=" font-basefont bg-gradient-to-tr from-yellow-100 to-orange-200 font-basefont flex flex-col items-center justify-center min-h-screen py-16">
      <div className="relative w-48 h-48 mb-10">
        <div className="absolute top-0 left-0 w-full h-full rounded-md bg-orange-400 transform rotate-45 shadow-lg"></div>
        <div className="absolute top-4 left-4 w-full h-full rounded-md bg-yellow-500 transform -rotate-12 opacity-70"></div>
        <div className="absolute top-8 left-8 w-full h-full rounded-md bg-red-300 transform rotate-6 opacity-60"></div>
        <div className="absolute top-12 left-12 w-full h-full rounded-md bg-amber-400 transform -rotate-3 opacity-50"></div>
        <div className="absolute top-16 left-16 w-full h-full rounded-md bg-orange-300 transform rotate-2 opacity-40"></div>
      </div>
      <div className="text-center">
        <p className="text-xl text-gray-800 mb-6 mt-12">
          Lost signal. Page not found.
        </p>
        <p className="text-lg text-gray-600 mb-8">
        </p>
        <NavLink
          to="/"
          className="bg-basecolor text-white font-semibold rounded-md text-lg px-5 py-3 hover:from-blue-600 hover:to-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1 shadow-xl"
        >
          Return to Home
        </NavLink>
      </div>
    </div>
  );
};

export default Page404;